<nz-spin [nzSpinning]="loading$ | async">
  <form nz-form class="form" nzLayout="horizontal" [formGroup]="reportTypeForm">
    <div class="drawer-form-wrapper">
      <div class="behaviour-card-sec" *ngIf="caseDetail && caseDetail.student">
        <div class="header-with-cta mb-24">
          <h3 class="title s-18">
            {{ caseDetail.student.firstName }} {{ caseDetail.student.lastName }}
          </h3>
        </div>
        <div class="card-content-wrapper">
          <div class="content">
            <h4 class="title">Date Of Birth</h4>
            <p class="desc">
              <svg-icon
                src="/assets/icon/icon-calendar.svg"
                class="icon s-16"
                aria-label="Calendar"></svg-icon>
              {{ caseDetail.student.dateOfBirth | date: 'MM/dd/yyyy' }}
            </p>
          </div>
          <div class="content">
            <h4 class="title">Supervisor</h4>
            <p class="desc">
              <svg-icon
                src="/assets/icon/icon-supervisor.svg"
                class="icon s-16"
                aria-label="Supervisor"></svg-icon>
              {{ caseDetail.supervisorName }}
            </p>
          </div>
          <div class="content">
            <h4 class="title">Gender</h4>
            <p class="desc">
              <svg-icon
                src="/assets/icon/icon-male.svg"
                class="icon s-18"
                aria-label="Male"></svg-icon>
              {{ caseDetail.student.gender }}
            </p>
          </div>
        </div>
      </div>
      <div class="header-with-cta mb-24">
        <h3 class="title s-18">Available Options</h3>
      </div>
      <!-- options -->
      <div class="radio-wrapper mb-24">
        <nz-radio-group
          id="languageLevel"
          nzName="radiogroup"
          formControlName="reportType">
          <span
            nz-radio
            nzValue="create"
            [nzDisabled]="!allowCreateReport"
            class="box-radio">
            Create a new report
          </span>
          <span nz-radio nzValue="print" class="box-radio">
            Download / Edit existing report
          </span>
        </nz-radio-group>
      </div>
      <div class="display-flex justify-content-between drawer-footer">
        <button nz-button type="button" nzType="default" (click)="onCancel()">
          Cancel
        </button>
        <div class="footer-right">
          <button
            nz-button
            type="button"
            nzType="primary"
            [disabled]="!reportTypeForm.valid"
            (click)="onNext()">
            Next
          </button>
        </div>
      </div>
    </div>
  </form>
</nz-spin>
<ng-template #createTpl>
  <app-drawer-header
    [title]="'Create Report'"
    [subtitle]="'Create Report'"
    breadcrumbText="{{ caseDetail.student.firstName }}'s"
    (drawerClose)="onCancel()">
  </app-drawer-header>
</ng-template>
<ng-template #editTpl>
  <app-drawer-header
    [title]="'Download/Edit an existing Report'"
    [subtitle]="'Download/Edit an existing Report'"
    breadcrumbText="{{ caseDetail.student.firstName }}'s"
    (drawerClose)="closerEditDrawer()">
  </app-drawer-header>
</ng-template>
